import { useAuth } from '@/app/context';
import { UserGroup } from '@/shared/utils/get-group';
import { useEffect, useState } from 'react';

/**
 * Administrador da seguradora — o perfil que o backend exige com
 * `@RequireGroups('insurer.administrator')`.
 *
 * Mais estreito que `useIsInsurerUser`, que aceita os seis perfis da
 * seguradora. Use quando o gate precisa bater com o do backend; usar o mais
 * amplo mostraria a ação para quem vai tomar 403.
 *
 * Esconder o botão é conveniência, não segurança: a API rejeita a chamada
 * direta de quem não é Administrador.
 */
export function useIsInsurerAdministrator() {
  const { checkUserGroups } = useAuth();
  const [isInsurerAdministrator, setIsInsurerAdministrator] = useState<
    boolean | null
  >(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const check = async () => {
      setIsLoading(true);
      const result = await checkUserGroups([UserGroup.INSURER_ADMINISTRATOR]);
      setIsInsurerAdministrator(result);
      setIsLoading(false);
    };

    check();
  }, [checkUserGroups]);

  return { isInsurerAdministrator, isLoading };
}
